<template>
    <div
        v-bind:id="[showList ? 'be-lista-ordini' : 'be-ordine']"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <loading-animation
                class="loading"
                v-show="loading"
            />
            <main v-show="!loading && showList">
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-8">
                                <h1 class="mb-0">{{$t('Ordini')}}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="controlli-elenco mt-5 row d-flex justify-content-between align-items-center flex-wrap">
                        <div class="col-md-3">
                            <button
                                type="button"
                                class="btn btn-light border"
                                v-b-modal.popupricerca
                            >
                                {{$t('Ricerca con filtri')}}</button>
                        </div>
                        <div class="row filters-labels col-md-12 mt-2">

                            <b-alert
                                dismissible
                                :show="searchOrder.num !== ''"
                                @dismissed="clearFilter('num')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Ordine')}}: {{searchOrder.num}}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchOrder.gallery !== ''"
                                @dismissed="clearFilter('gallery')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Gallery')}}: {{getGalleryLabel(searchOrder.gallery)}}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchOrder.name !== ''"
                                @dismissed="clearFilter('name')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Cliente')}}: {{searchOrder.name}}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchOrder.email !== ''"
                                @dismissed="clearFilter('email')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Email')}}: {{searchOrder.email}}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchOrder.status !== ''"
                                @dismissed="clearFilter('status')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Stato')}}: {{getStatusLabel(searchOrder.status)}}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="!isAgent && searchOrder.agent !== ''"
                                @dismissed="clearFilter('agent')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Agente')}}: {{getAgentLabel(searchOrder.agent)}}</small>
                            </b-alert>
                            <div class="align-middle mt-1">
                                <a
                                    class="ml-2"
                                    href=""
                                    v-if="searchOrder.num !== '' || searchOrder.gallery !== '' || searchOrder.name !== '' || searchOrder.email !== '' || searchOrder.status !== '' || (!isAgent && searchOrder.agent !== '')"
                                    @click.prevent="clearFilter()"
                                >
                                    <small>{{$t('Pulisci tutti i filtri')}}</small>
                                </a>
                            </div>
                        </div>

                        <!--
                        <div class="d-md-flex justify-content-end align-items-center col-md-9 mt-3 mt-md-0">
                            <div class="dropdown d-none">
                                <button
                                    class="btn btn-light border dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >Azioni
                                </button>
                                <div
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                    >Segna come Pagato</a>
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                    >Segna come In sospeso</a>
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                    >Segna come In elaborazione</a>
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                    >Segna come Completato</a>
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                    >Annulla ordine</a>
                                </div>
                            </div>
                        </div>
                        -->
                    </div>

                    <b-table
                        class="elenco-ordini tabella-responsive table table-striped mt-3 mb-0"
                        striped
                        id="orders-table"
                        :per-page="pagination.perPage"
                        :current-page="pagination.currentPage"
                        :fields="tableHead"
                        :items="filteredOrders"
                        :tbody-tr-class="'ordine mt-0'"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >

                        <!-- HEAD -->
                        <template #head(num)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(creationDate)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(name)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(eventTitle)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(status)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(total)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>

                        <!-- TABLE BODY DATA -->
                        <template #cell(num)="data">
                            <a
                                href="#"
                                @click="showOrderDetail(data.item.num)"
                            >{{ data.item.num }}
                            </a>
                        </template>

                        <template #cell(creationDate)="data">
                            <span class="data-ordine">{{data.item.creationDate | formatDateSlash}}</span>
                        </template>

                        <template #cell(name)="data">
                            <span class="nome-cliente">{{data.item.name}}</span>
                        </template>

                        <template #cell(eventTitle)="data">
                            <span class="titolo-gallery">{{data.item.eventTitle}}</span>
                        </template>

                        <template #cell(status)="data">
                            <span class="status">{{getStatusLabel(data.item.status)}}</span>
                        </template>

                        <template #cell(total)="data">
                            <span class="totale font-titoli-rikorda text-blurikorda align-right">{{parseFloat(data.item.total) | toCurrency}}</span>
                        </template>

                    </b-table>

                    <nav
                        class="paginazione mt-3"
                        aria-label="Paginazione"
                    >
                        <b-pagination
                            v-model="pagination.currentPage"
                            :total-rows="paginationRows"
                            :per-page="pagination.perPage"
                            aria-controls="orders-table"
                            align="right"
                            class="pagination justify-content-end mb-0"
                        />
                    </nav>

                </div>
            </main>
            <backend-sales-detail
                v-show="showDetail"
                v-bind:order="orderDetail"
                @showOrdersList="showOrdersList"
            />
            <backend-footer />
            <!-- popup ricerca ordini -->
            <b-modal
                id="popupricerca"
                :title="$t('Cerca ordini')"
                @ok="onPopupRicercaOk"
            >
                <div class="form-group mt-1 mb-2">
                    <label
                        for="num"
                        class="mb-0"
                    >{{$t('Ordine')}} #</label>
                    <input
                        ref="popupRicercaOrdine"
                        type="text"
                        class="form-control"
                        name="num"
                        id="num"
                        :value="searchOrder.num"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="gallery"
                        class="mb-0"
                    >{{$t('Gallery')}}</label>

                    <!--b-form-input
                        ref="popupRicercaGallery"
                        list="gallery"
                        autocomplete="off"
                        placeholder="Qualsiasi"
                        :value="searchOrder.gallery"
                        class="datalist-select"
                    ></b-form-input>

                    <b-form-datalist
                        name="gallery"
                        id="gallery"
                    >
                        <option value="">{{$t('Qualsiasi')}}</option>
                        <option
                            v-for="gallery in galleries"
                            :key="gallery.id"
                            :value="gallery.title"
                        >{{ gallery.title }}</option>
                    </b-form-datalist-->

                    <b-form-select
                        class="form-control"
                        name="gallery"
                        id="gallery"
                        ref="popupRicercaGallery"
                        :value="searchOrder.gallery"
                    >
                        <option value="">{{$t('Qualsiasi')}}</option>
                        <option
                            v-for="gallery in galleries"
                            :key="gallery.id"
                            :value="gallery.id"
                        >
                            {{gallery.title}}
                        </option>
                    </b-form-select>
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="cliente"
                        class="mb-0"
                    >{{('Nome cliente')}}</label>
                    <input
                        ref="popupRicercaCliente"
                        type="text"
                        class="form-control"
                        name="cliente"
                        id="cliente"
                        :value="searchOrder.name"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="email"
                        class="mb-0"
                    >{{('Email cliente')}}</label>
                    <input
                        ref="popupRicercaEmail"
                        type="text"
                        class="form-control"
                        name="email"
                        id="email"
                        :value="searchOrder.email"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="filtri"
                        class="mb-0"
                    >{{('Status ordini')}}</label>
                    <b-form-select
                        ref="popupRicercaStatus"
                        class="form-control"
                        name="filtri"
                        id="filtri"
                        :value="searchOrder.status"
                    >
                        <option value="">Tutti</option>
                        <option value="0">{{$t('In elaborazione')}}</option>
                        <option value="1">{{$t('Sospeso')}}</option>
                        <option value="2">{{$t('In stampa')}}</option>
                        <option value="6">{{$t('Spedito')}}</option>
                        <option value="8">{{$t('Annullato')}}</option>
                        <option value="P">{{$t('Da pagare')}}</option>
                        <option value="A">{{$t('In attesa di attivazione')}}</option>
                    </b-form-select>
                </div>
                <div
                    class="form-group mt-1 mb-2"
                    v-if="!isAgent"
                >
                    <label class="mb-0">{{ $t("Collaboratore") }}</label>
                    <b-form-select
                        ref="popupRicercaAgent"
                        class="form-control"
                        :value="searchOrder.agent"
                        :options="agents"
                        value-field="fkUtenteAgente"
                        text-field="email"
                        required
                    >
                        <template #first>
                            <b-form-select-option value="">{{$t('Tutti')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </div>
                <template #modal-footer="{ok,cancel}">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Cerca") }}
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../../components/backend/Header";
import BackendFooter from "../../../components/backend/Footer";
import BackendSalesDetail from "./Detail";
import LoadingAnimation from "../../../components/LoadingAnimation";

export default {
    name: "BackendSalesOrders",
    components: {
        LoadingAnimation,
        BackendHeader,
        BackendFooter,
        BackendSalesDetail
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1
            },
            sortBy: "creationDate",
            sortDesc: true,
            tableHead: [
                {
                    key: "num",
                    label: "# Ordine",
                    tdAttr: { "data-title": "Ordine #" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "creationDate",
                    label: "Data",
                    tdAttr: { "data-title": "Data" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "name",
                    label: "Cliente",
                    tdAttr: { "data-title": "Cliente" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "eventTitle",
                    label: "Gallery",
                    tdAttr: { "data-title": "Gallery" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "status",
                    label: "Stato",
                    tdAttr: { "data-title": "Stato" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "total",
                    label: "Totale",
                    tdAttr: { "data-title": "Totale" },
                    tdClass: "align-middle px-1",
                    sortable: true
                }
            ],
            orders: [],
            filteredOrders: [],
            galleries: [],
            searchOrder: {
                num: "",
                gallery: "",
                name: "",
                email: "",
                status: "",
                agent: ""
            },
            orderDetail: {},
            showDetail: false,
            showList: true,
            loading: false,
            agents: []
        };
    },
    methods: {
        onPopupRicercaOk() {
            this.searchOrder.num = this.$refs.popupRicercaOrdine.value;
            this.searchOrder.name = this.$refs.popupRicercaCliente.value;
            this.searchOrder.email = this.$refs.popupRicercaEmail.value;
            this.searchOrder.gallery = this.$refs.popupRicercaGallery.$el.value;
            this.searchOrder.status = this.$refs.popupRicercaStatus.$el.value;
            if (!this.isAgent) {
                this.searchOrder.agent = this.$refs.popupRicercaAgent.$el.value;
            }
            this.filterCustom();
        },

        filterCustom() {
            this.filteredOrders = this.orders.filter((order) => {
                if (order.name === null) {
                    order.name = "";
                }
                return (
                    order.num.includes(this.searchOrder.num) &&
                    order.name.includes(this.searchOrder.name) &&
                    order.email.includes(this.searchOrder.email) &&
                    (this.searchOrder.gallery !== ""
                        ? order.eventId === this.searchOrder.gallery
                        : true) &&
                    (this.searchOrder.status !== ""
                        ? this.searchOrder.status === "2"
                            ? [2, 3, 4, 5].includes(order.status)
                            : this.searchOrder.status == order.status
                        : true) &&
                    (this.searchOrder.agent !== ""
                        ? order.fkUtenteAgente === this.searchOrder.agent
                        : true)
                );
            });
        },
        clearFilter(filter) {
            switch (filter) {
                case "num":
                    this.searchOrder.num = "";
                    this.filterCustom();
                    break;
                case "gallery":
                    this.searchOrder.gallery = "";
                    this.filterCustom();
                    break;
                case "name":
                    this.searchOrder.name = "";
                    this.filterCustom();
                    break;
                case "email":
                    this.searchOrder.email = "";
                    this.filterCustom();
                    break;
                case "status":
                    this.searchOrder.status = "";
                    this.filterCustom();
                    break;
                case "agent":
                    if (!this.isAgent) {
                        this.searchOrder.agent = "";
                    }
                    this.filterCustom();
                    break;
                default:
                    this.searchOrder.num = "";
                    this.searchOrder.gallery = "";
                    this.searchOrder.name = "";
                    this.searchOrder.email = "";
                    this.searchOrder.status = "";
                    if (!this.isAgent) {
                        this.searchOrder.agent = "";
                    }
                    this.filterCustom();
                    break;
            }
        },
        showOrderDetail(orderNum) {
            this.orderDetail = this.orders.filter(
                (item) => item.num === orderNum
            );
            this.orderDetail = this.orderDetail[0];
            this.showList = false;
            this.showDetail = true;
        },
        showOrdersList() {
            //this.orderDetail = {};
            this.showDetail = false;
            this.showList = true;
        },
        showOrderMenu(order) {
            var result = false;
            switch (order.status) {
                case "A":
                    result = true;
                    break;
            }
            return result;
        },
        forceUserActivation(order) {
            this.$api
                .backendForceActivateAccountByOrderId(order.id)
                .then((result) => {
                    console.debug("FORCE_USER_ACTIVATION", result);
                    location.reload();
                })
                .catch((error) => {
                    console.error("FORCE_USER_ACTIVATION", error);
                });
        },
        getGalleryLabel(galleryId) {
            let gallery = this.galleries.filter((el) => el.id === galleryId);
            return gallery[0] ? gallery[0].title : "";
        },
        getStatusLabel(status) {
            switch (status) {
                case "0":
                    return "Da elaborare";
                case "1":
                    return "Sospeso";
                case "2":
                case "3":
                case "4":
                case "5":
                    return "In stampa";
                case "6":
                    return "Spedito";
                case "7":
                    return "Consegnato";
                case "8":
                    return "Annullato";
                case "V":
                case "P":
                    return "Da pagare";
                case "A":
                    return "In attesa di attivazione";
                default:
                    return "-";
            }
        },
        getAgentLabel(fkUtenteAgente) {
            if (!this.isAgent) {
                let agent = this.agents.filter(
                    (el) => el.fkUtenteAgente === fkUtenteAgente
                );
                return agent[0] ? agent[0].email : "";
            }
            return "";
        }
    },
    mounted: function () {
        this.loading = true;
        this.$api
            .backendGetOrders()
            .then((result) => {
                console.debug("BACKEND_GET_ORDERS", result);
                this.orders = result.orders;
                this.filteredOrders = this.orders;
                this.galleries = result.eventsList;
                this.agents = result.agents;
                if (this.isAgent && this.orders.length > 0) {
                    this.searchOrder.agent = this.orders[0].fkUtenteAgente;
                }
                let orderNum = this.$route.params.orderNum;
                if (orderNum) {
                    this.showOrderDetail(orderNum);
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_ORDERS", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            })
            .finally(() => {
                this.loading = false;
            });
    },
    computed: {
        paginationRows() {
            return this.filteredOrders.length;
        },
        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        }
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 50%;
    left: calc(50% - 41px);
}
</style>
